import React, { useEffect, useRef,useState,useContext } from 'react';
import { loadModules } from 'esri-loader';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faRoad, faHome, faPlus, faMinus, faTimes, faExclamationCircle, faQuestion } from '@fortawesome/free-solid-svg-icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Box } from '@material-ui/core';
import Cookies from 'js-cookie';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import API_PATH from "../../constants/config.json";
import { clearCookie } from '../../functions/Auth';
import { useHistory } from 'react-router-dom';

import CssBaseline from '@material-ui/core/CssBaseline';
import FilledInput from '@material-ui/core/FilledInput';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useTheme } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import Container from '@material-ui/core/Container';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LaneGeometry from './LaneGeometry';
import MapContext from '../../context/MapContext'
import Autocomplete from "react-google-autocomplete";
import Checkbox from '@material-ui/core/Checkbox';

const axios = require('axios');

const API_URL = process.env.REACT_APP_BASE_URL;
let station_type=1


let aproachDetailsError=[true,true,true,true];
let losDirectionsError=[];
let aproachDetailsErrorMid=[true,true];
function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
    );
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
  
function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}

//Start Css code ...
const useStyles = makeStyles((theme) => ({
    root: {
        '& .esri-ui-bottom-right' :{
            padding: "0px 10px 10px 10px",
            right: "30px !important",
              bottom: "14px !important",
          },
        flexGrow: 1,
        '& .MuiTextField-root': {
            width: '100%',
            '@media only screen and (min-width: 3501px)': {              
                marginBottom:'20px',
            },
            '& input': {
                padding: '10px',                
                color: '#333',
                '@media only screen and (max-width: 3500px)': {
                    fontSize: '13pt',
                },
                '@media only screen and (min-width: 3501px)': {
                    fontSize: '23pt',                   
                },
            },
        }
    },
    paper: {
        padding: '0px 0px',
        boxShadow: 'none',
    },
    fieldsetname: {
        width: 'auto',
        border: '1px solid rgba(0, 167, 93, 1)',
        padding: '10px 10px 25px',
        marginTop: '15px',
        borderRadius: '5px',
        '& p': {
            margin: '0',
        },
        '& .MuiGrid-item': {
            paddingBottom: '0px',
        }
    },
    fieldsetnameInner: {
        width: '90%',
        border: '1px solid #ccc',
        padding: '10px 10px 25px',
        marginTop: '15px',
        borderRadius: '5px',
        '& p': {
            margin: '0',
        },
        '& .MuiGrid-item': {
            paddingBottom: '0px',
        }
    },
    selectOption: {
        width: '100%',
        padding: '10px 5px',
        border: '1px solid #c5c5c5',
        background: '#fff',
        borderRadius: '3px',        
        color: '#333',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '12pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt',
            marginBottom:'20px',
        },
    },
    labelText: {
        width: '100%',
        float: 'left',
        color: '#333',        
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
        },
    },
    rootForm: {
        '@media only screen and (max-width: 3500px)': {
            '& h5': {                
                margin: '0',
            }
        },
        '@media only screen and (min-width: 3501px)': {
            '& h5': {
                fontSize: '28pt !important',
                margin: '0',
                marginTop: '10px',
            }
        },
    },
    locationMapView: {
        '& img': {
            width: '100%',
        },   
        position:'relative',     
        width: '100%',
        '@media only screen and (max-width: 3500px)': {
            height: '278px',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '278px',
        },
    },
    btbBlock: {
        float: 'right',
    },
    btbBlock2: {
        width: '49%',
        textAlign: 'right',
        paddingBottom: '10px',
        '@media only screen and (max-width: 3500px)': {
            marginBottom:'10px',
        },
        '@media only screen and (min-width: 3501px)': {
            marginBottom:'25px',
        },
    },
    addStationBtn: {
        border: '1px solid #24618E',
        color: '#fff',
        background: '#24618E!important',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
            width: '150px',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',  
            width: '225px',          
        },
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        },
        '& .MuiCircularProgress-root': {
            width: '25px !important',
            height: '25px !important',
            color: '#fff'
        }
    },
    cancelBtn: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        fontSize: '12px',
        width: '150px',
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        },
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
            width: '150px',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',  
            width: '225px',          
        },
    },
    importStationFile: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        fontSize: '12px',
        width: '200px',
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        }
    },
    mapViewSection: {
        padding: '0 15px 0px 25px',
        marginTop: '50px',
        '& .hideInteraction': {
            display: 'none',
        },
        '& .hideMidBlock': {
            display: 'none',
        }
    },
    interApprochMainBlock: {
        width: '100%',
        float: 'left',
        '& .inter-left': {
            width: '20%',
            float: 'left',
            paddingRight: '5px',
            paddingBottom: '15px',
        },
        '& .inter-right': {
            width: '78%',
            float: 'right',
            paddingLeft: '5px',
            paddingBottom: '15px',
            display: 'flex'
        }
    },
    homeIcon: {
        position: 'relative',
        color: '#24618E',
        border: '1px solid #D4D4D8',
        background: '#fff',
        textAlign: 'center',
        padding: '5px',
        marginBottom: '10px',
        cursor: 'pointer',
        borderRadius: '6px',
        zIndex: '1',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)',
        '@media only screen and (max-width: 3500px)': {
            width: '38px',
            height: '38px'
        },
        '@media only screen and (min-width: 3501px)': {
            width: '38px',
            height: '38px',
            '& svg': {
                fontSize: '35pt',
            }
        },
    },
    zoomIcon: {
        position: 'relative',
        color: '#24618E',
        border: '1px solid #D4D4D8',
        background: '#fff',
        textAlign: 'center',
        padding: '5px',
        marginBottom: '10px',
        cursor: 'pointer',
        borderRadius: '6px',
        zIndex: '1',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)',
        '@media only screen and (max-width: 3500px)': {
            width: '40px',
            fontSize: '20px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '70px',
            height: '65px',
            '& svg': {
                fontSize: '35pt',
            }
        },
    },
    inIcon: {
        position: 'relative',
        color: '#24618E',
        border: '1px solid #D4D4D8',
        background: '#fff',
        textAlign: 'center',
        padding: '5px',
        marginBottom: '10px',
        cursor: 'pointer',
        borderRadius: '6px',
        zIndex: '1',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)',
        '@media only screen and (max-width: 3500px)': {
            width: '40px',
            fontSize: '20px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '70px',
            height: '65px',
            '& svg': {
                fontSize: '35pt',
            }
        },
    },
    mapContainer: {
        width: '100% !important',
        display: 'block !important',
        '@media only screen and (max-width: 3500px)': {
            height: '278px !important'
        },
        '@media only screen and (min-width: 3501px)': {
            height: '278px !important',
        },
        '& .esri-view-root': {
            height: '100% !important',
            width: '100% !important'
        }
    },
    rightClickInfo: {
        position: 'relative',       
        border: '1px solid #24618E',
        textAlign: 'center',
        padding: '5px',
        background: '#f2f2f2',
        marginTop: '-5px',
        borderTop: 'none',
        borderLeft: 'none',
        marginLeft: '-13px',
        '@media only screen and (max-width: 3500px)': {
            width: '400px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '650px',
            fontSize:'24pt'
        },
    },
    errorInput: {
        width: '100%',
        backgroundColor: '#F2DEDE',
        border: '1px solid #CC0000',
        padding: '10px 5px',
        borderRadius: '3px',        
        color: '#333',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '12pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt',
        },
    },
    errIcon: {
        fontSize: '26px',
        color: '#CC0000',
        margin: '2%'
    },
    approachError: {
        flex:1,
       
    },
    iconBox:{
        position: 'absolute', 
        width: 'max-content',        
        width: 'max-content',        
        paddingLeft: '0px',        
        '@media only screen and (max-width: 3500px)': {            
            right: '8px',
            bottom: '8px',
        },
        '@media only screen and (min-width: 3501px)': {
            bottom: '8px',
            right: '8px',
        },
    }
}));
//End Css code ...

let tempValues = {
    station_type: 0,
    station_privacy: 1,
    station_location: '',
    display_name: '',
    client_station_id: '',
    status: 'active',
    latitude: 0,
    longitude: 0,
    state_code: '',
    fips_county_code: '',
    jurisdiction: '',
    community: '',
    speed_limit: null,
    FK_functional_classification_code: null,
    FK_primary_purpose: null,
    description: '',
    seasonal_factor_group: '',
    annual_factor_group: '',
    growth_factor_group: '',
    year_station_established: null,
    national_highway_system: null,
    FK_posted_route_signing: null,
    posted_signed_route_number: '',
    nb_approach: '',
    sb_approach: '',
    swb_approach: '',
    seb_approach: '',
    neb_approach: '',
    nwb_approach: '',
    eb_approach: '',
    wb_approach: ''
};
let speedLimitField = 'none';

//Start AddNewStation component code ...
const AddNewStation = props => {
    const theme = useTheme();
    const [value, setValue] = useState(0);
    let history = useHistory();
    const [interactionApproch, setInteractionApproch] = React.useState("hideInteraction");
    const [midBlockApproch, setMidBlockApproch] = React.useState("hideMidBlock");
    const [home, setHome] = React.useState(null);
    const [zoom, setZoom] = React.useState(null);
    const [lat, setLat] = React.useState('');
    const [long, setLong] = React.useState('');
    const [checkedGoogle, setCheckedGoogle] = React.useState(false);
    const [stationLocation, setStationLocation] = React.useState('');
    const [region, setRegion] = React.useState('');
    const [county, setCounty] = React.useState('');
    const [errPopUp, setErrPopUp] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [loader, setLoader] = React.useState(false);

    const [fccDropdown, setFccDropdown] = React.useState([]);
    const [primaryPurposeDropdown, setPrimaryPurposeDropdown] = React.useState([]);
    const [prsDropdown, setPrsDropdown] = React.useState([]);

    const [approachError, setApproachError] = React.useState(false);
    const [midApproachSelectOneErr, setMidApproachSelectOneErr] = React.useState(false);
    const [midApproachSelectTwoErr, setMidApproachSelectTwoErr] = React.useState(false);

    const [intApproachSelectOneErr, setIntApproachSelectOneErr] = React.useState(false);
    const [intApproachSelectTwoErr, setIntApproachSelectTwoErr] = React.useState(false);
    const [intApproachSelectThreeErr, setIntApproachSelectThreeErr] = React.useState(false);
    const [intApproachSelectFourErr, setIntApproachSelectFourErr] = React.useState(false);

    const [midAllApproaches, setMidAllApproaches] = React.useState({
        approachOne: {},
        approachTwo: {}
    });

    const [intAllApproaches, setIntAllApproaches] = React.useState({
        approachOne: {},
        approachTwo: {},
        approachThree: {},
        approachFour: {}
    });

    const [values, setValues] = React.useState({
        station_type: 1,
        station_privacy: 1,
        station_location: '',
        display_name: '',
        client_station_id: '',
        status: 'active',
        latitude: 0,
        longitude: 0,
        state_code: '',
        fips_county_code: '',
        jurisdiction: '',
        community: '',
        speed_limit: null,
        FK_functional_classification_code: null,
        FK_primary_purpose: null,
        description: '',
        seasonal_factor_group: '',
        annual_factor_group: '',
        growth_factor_group: '',
        year_station_established: null,
        national_highway_system: null,
        FK_posted_route_signing: null,
        posted_signed_route_number: '',
        nb_approach: '',
        sb_approach: '',
        swb_approach: '',
        seb_approach: '',
        neb_approach: '',
        nwb_approach: '',
        eb_approach: '',
        wb_approach: ''
    });
    
    const [scrolled, setScrolled] = useState(false);
    const mainBgRef = useRef();

    const mapRef = useRef();
    const classes = useStyles();
    let view = null;
    let acccessToken = null;

    const [tempMapView, setTempMapView] = React.useState(null);
    const [geocodeAcccessToken, setGeocodeAcccessToken] = React.useState(null);
    const [stationTypeValue, setStationTypeValue] = React.useState([]);

    const [stationLocationError,setStationLocationError]= React.useState(true);
    const [displayNameError,setDisplayNameError]= React.useState(true);
    const [stationIdError,setStationIdError]= React.useState(true);
    const [stationLatitudeError,setStationLatitudeError]= React.useState(true);
    const [stationLongitudeError,setStationLongitudeError]= React.useState(true);
    const [stationDetailsError,setStationDetailsError]= React.useState(false);
    const [formErrorMessage,setFormErrorMessage]= React.useState('Field cannot be empty');
    const [stationId, setStationId] = React.useState("");
    const [stationType, setStationType] = React.useState(1);
    const [markerPosition, setMarkerPosition] = React.useState(null);

    const [laneConfigId, setLaneConfigId] = React.useState(null);
    const [showLaneConfig, setShowLaneConfig] = React.useState(false);
    const [losEnabled, setLosEnabled] = React.useState(false);
    const [showLOS, setShowLOS] = React.useState(false);
    const [selectedAreaClassification, setSelectedAreaClassification] = React.useState([]);
    const {updAddNewStation}=useContext(MapContext)

    const [areaClassifications, setAreaClassifications] = useState([]);
    const [medianTypes, setMedianTypes] = useState([]);

    const [areaClassError, setAreaClassError] = useState(false);
    const [medianTypeError, setMedianTypeError] = useState(false);

    const [losDisabledApproaches, setLosDisabledApproaches] = useState([]);
    
    useEffect(() => {
        if(stationType){
            axios({
                method: 'post',
                data: {
                    station_type: stationType
                },
                headers: {
                  'payload': Cookies.get('payload'),
                  'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.getLastStationsAPIv2,
              })
            .then(async function (response) {
                var lastStationId = response.data.data.result.client_station_id;                
                var rec = '';
                console.log('lastStationId', lastStationId)
                console.log('lastStationIdmatcj', lastStationId.match(/(\d+)$/))
                if (lastStationId.match(/(\d+)$/)){
                    var rec = lastStationId.replace(/(\d+)$/, function(match) {
                        var numericVal = match
                        console.log('match', match)
                        console.log('numericVal', numericVal)
                        console.log('parseInt(numericVal)', parseInt(numericVal))
                        var nextNumber = parseInt(numericVal) + 1;
                        console.log('nextNumber', nextNumber)
                        console.log('numericVal.length', numericVal.length)
                        var numericPartWithLeadingZeros = nextNumber.toString().padStart(numericVal.length, '0');
                        console.log('numericPartWithLeadingZeros', numericPartWithLeadingZeros)
                        return numericPartWithLeadingZeros;
                    });
                }else{
                    rec = lastStationId+"-001"
                }
                setStationIdError(false);
                setStationId(rec);
                setValues({ ...values, client_station_id: rec});
                tempValues = { ...values, client_station_id: rec};
            })
        }
    }, [stationType])

    const changeLocation = async(evt) => {
        try {
            const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${evt.mapPoint.latitude},${evt.mapPoint.longitude}&key=${process.env.REACT_APP_MAPS_KEY}`
            );
            if (response.ok) {
                const data = await response.json();
                if (data.results.length > 0) {
                const locationInfo = data.results[0].formatted_address;                                    
                setStationLocation(locationInfo);
                setValues({ ...tempValues, station_location: locationInfo, latitude: parseFloat(evt.mapPoint.latitude), longitude: parseFloat(evt.mapPoint.longitude) });
                tempValues = { ...tempValues, station_location: locationInfo, latitude: parseFloat(evt.mapPoint.latitude), longitude: parseFloat(evt.mapPoint.longitude) };
                setStationLocationError(false);
                var state = ''
                var county = ''
                data.results[0].address_components.forEach((component) => {
                    const componentTypes = component.types;
                    if (componentTypes.includes("administrative_area_level_1")) {
                        state = component.short_name;
                    }
                    if (componentTypes.includes("country")) {
                        county = component.short_name;
                    }
                });
                if(state){
                    setRegion(state)
                }
                if(county){
                    setCounty(county)
                }
                } else {
                    setValues({ ...tempValues, latitude: parseFloat(evt.mapPoint.latitude), longitude: parseFloat(evt.mapPoint.longitude) });
                    tempValues = { ...tempValues, latitude: parseFloat(evt.mapPoint.latitude), longitude: parseFloat(evt.mapPoint.longitude) };
                    console.log("No results found for the given coordinates.");
                }
            } else {
                setValues({ ...tempValues, latitude: parseFloat(evt.mapPoint.latitude), longitude: parseFloat(evt.mapPoint.longitude) });
                tempValues = { ...tempValues, latitude: parseFloat(evt.mapPoint.latitude), longitude: parseFloat(evt.mapPoint.longitude) };
                console.log("Error fetching location data.");
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }
    
    useEffect(
        () => {
            let mapType = Cookies.get('stationDetailsMap') && Cookies.get('stationDetailsMap') !== '' ? Cookies.get('stationDetailsMap') : 'streets-navigation-vector';
            let mapTypePrev = Cookies.get('stationDetailsMap') && Cookies.get('stationDetailsMap') === 'hybrid' ? 'streets-navigation-vector' : 'hybrid';
            aproachDetailsError=[true,true,true,true]
            losDirectionsError=[]
            aproachDetailsErrorMid=[true,true]
            tempValues = {...values};
            station_type=1
            getMapAccessToken();
            // getFFCdropdown();
            // getPrimPPdropdown();
            // getPRSdropdown();
            getStationTypeData();
            getAreaClassifications();
            getMedianType();
            // lazy load the required ArcGIS API for JavaScript modules and CSS
            loadModules(['esri/Map', 'esri/views/MapView', "esri/widgets/Home", "esri/widgets/Zoom", "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic", "esri/layers/GraphicsLayer", "esri/symbols/PictureMarkerSymbol", "esri/widgets/Search",
            "esri/widgets/BasemapToggle",
            "esri/widgets/BasemapGallery"], { css: true })
                .then(([ArcGISMap, MapView, Home, Zoom, FeatureLayer, Viewpoint, Point, Graphic, GraphicsLayer, PictureMarkerSymbol, Search,
                    BasemapToggle, BasemapGallery]) => {
                    const map = new ArcGISMap({
                        basemap: mapType,
                        slider: false
                    });

                    view = new MapView({
                        container: mapRef.current,
                        map: map,
                        // center: [-106.61, 35.1107],
                        zoom: 4,
                        ui: {
                            components: ['home', 'locate'] // specify only the components you want
                        },
                    });
                    var basemapToggle = new BasemapToggle({
                        view: view,  // The view that provides access to the map's "streets-vector" basemap
                        nextBasemap: mapTypePrev  // Allows for toggling to the "hybrid" basemap
                      });
                
                     view.ui.add(basemapToggle,"bottom-left");
                      

                    
                    
                    setTempMapView(view)
                    let featureLayer = new FeatureLayer({
                        url: sessionStorage.getItem('mapURL')
                    });
                    featureLayer.when(function () { // adds feature layer to map view
                        let vp = new Viewpoint({
                            targetGeometry: featureLayer.fullExtent
                        });
                        homeButton.viewpoint = vp;
                        view.extent = featureLayer.fullExtent;

                    });
                    map.add(featureLayer);
                    var search = new Search({
                        view: view
                    });

                    let homeButton = new Home({
                        view: view,
                    });
                    let zoom = new Zoom({
                        view: view,
                    });
                    setHome(homeButton)
                    setZoom(zoom)

                    view.on("click", async(evt) => {
                        let path = require('../../assets/images/mapPoint.svg')
                        if (evt.button == 2) {
                            view.graphics.removeAll();

                            var point = new Point(evt.mapPoint.longitude, evt.mapPoint.latitude);

                            let pointSymbol = {
                                type: "simple-marker",
                                style: "circle",
                                color: "#00b15e",
                                size: 16,
                                outline: {
                                    color: "#3676bc",
                                    width: 0.5
                                }
                            }
                            let symbolInt = {
                                type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                                url: require("../../assets/icons/marker_Intersection.png"),
                                width: "42px",
                                height: "42px",
                                yoffset: "20px"
                              };
                              let symbolMid = {
                                type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                                url: require("../../assets/icons/marker_Midblock.png"),
                                width: "42px",
                                height: "42px",
                                yoffset: "20px"
                              };
                              if (station_type==1){
                                pointSymbol=symbolMid;
                              }else{
                                pointSymbol=symbolInt;
                              }
                            setMarkerPosition(point); 
                            var pointGraphic = new Graphic(point, pointSymbol);
                            setLat(evt.mapPoint.latitude);
                            setStationLatitudeError(false)
                            setLong(evt.mapPoint.longitude);
                            setStationLongitudeError(false)
                            changeLocation(evt);
                            view.graphics.add(pointGraphic);
                        }

                    });
                    
                   selectStationType(1,"station_type")
                            

                    return () => {
                        if (view) {
                            // destroy the map view
                            view.container = null;
                        }
                    };
                });
                
        }, []
    );
    

    const getStationTypeData = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getStationType,
            })
                .then(async function (response) {
                    if (response && response.status == 200) {
                        setStationTypeValue(response.data.data);
                    }
                    else {
                        setStationTypeValue([]);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const getAreaClassifications = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getAreaClassifications,
            })
                .then(async function (response) {
                    if (response && response.status == 200) {
                        setAreaClassifications(response.data.result);
                    }
                    else {
                        setAreaClassifications([]);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const getMedianType = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getMedianType,
            })
                .then(async function (response) {
                    if (response && response.status == 200) {
                        setMedianTypes(response.data.result);
                    }
                    else {
                        setMedianTypes([]);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const getMapAccessToken = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getArcGISToken,
                headers: {
                    'payload': Cookies.get('payload'),
                },
            })
                .then(async function (response) {
                    acccessToken = response.data.access_token;
                    setGeocodeAcccessToken(response.data.access_token);
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const ShowErrPopUP = () => {
        setErrPopUp(false)
    };

    const handleChange = name => async (event) => {
        setErrMsg(null);
        let value = null;
        let inputValue = event.target.value;
        let longitude = long;
        let latitude = lat;
        let location = stationLocation;
        let client_station_id_on_display_name = null;
        if (name == 'station_type' ||
            name == 'station_privacy' ||
            // name == 'speed_limit' ||
            name == 'FK_functional_classification_code' ||
            name == 'FK_posted_route_signing' || name == 'year_station_established') {
            value = inputValue ? parseInt(inputValue) : null;
        } else if (name == 'client_station_id') {
            if(inputValue==''){
                setStationIdError(true)
                setFormErrorMessage('Field cannot be empty')
            }else{
                setStationIdError(false)
            }
            if (/[ `!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?~]/.test(inputValue))
                return ;
            setStationId(inputValue);
        }else if (name == 'display_name') {
            if(inputValue==''){
                setDisplayNameError(true)
                setFormErrorMessage('Field cannot be empty')
            }else{
                setDisplayNameError(false)
            }
            let _value = inputValue;
            // if (/[ `!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?~]/.test(inputValue))
            //     _value = inputValue.replace(/[^a-zA-Z0-9-]/g, '');
            client_station_id_on_display_name = _value;
        } else if (name == 'FK_primary_purpose') {
            value = inputValue == 'Select' ? null : inputValue;
        } else if (name == 'national_highway_system') {
            if (inputValue == 'true') {
                value = true;
            } else {
                value = false;
            }
        } else if (name == 'latitude') {
            setLat(inputValue);
            latitude = inputValue;
            if(inputValue==''){
                setStationLatitudeError(true)
                setFormErrorMessage('Field cannot be empty')

            }else{
                setStationLatitudeError(false)

            }
            await setMarkerPointer(longitude, latitude);

        } else if (name == 'longitude') {
            setLong(inputValue);
            longitude = inputValue;
            if(inputValue==''){
                setStationLongitudeError(true)
                setFormErrorMessage('Field cannot be empty')

            }else{
                setStationLongitudeError(false)

            }
            await setMarkerPointer(longitude, latitude);

        } else if (name == 'station_location') {
            setStationLocation(inputValue);
            if(inputValue==''){
                setStationLocationError(true)
                setFormErrorMessage('Field cannot be empty')

            }else{
                setStationLocationError(false)

            }
            location = inputValue;
        } else if (name == 'speed_limit') {
            value = inputValue ? parseInt(inputValue) : null;
        } else if (name == 'posted_speed_limit') {
            value = inputValue ? parseInt(inputValue) : null;
        } else if (name == 'FK_area_classification_id') {
            if(inputValue === "") 
                setAreaClassError(true);
            else 
                setAreaClassError(false);
            value = inputValue ? parseInt(inputValue) : null;
        } else if (name == 'nb_num_lanes' || name == 'sb_num_lanes' || name == 'eb_num_lanes' ||name == 'wb_num_lanes') {
            let tmpAp = name.replace("_num_lanes","");
            if(inputValue==''){
                losDirectionsError.push(tmpAp);
                // losDirectionsError[0]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                // losDirectionsError[0]=false
                const idx = losDirectionsError.indexOf(tmpAp);
                if (idx > -1){
                    losDirectionsError.splice(idx, 1);
                }
            }
            value = inputValue ? parseInt(inputValue) : null;
        }
        else if (name == 'nb_left_turn_within_100_yards') {
            value = inputValue ? inputValue : null;
        }else if (name == 'sb_left_turn_within_100_yards') {
            value = inputValue ? inputValue : null;
        }else if (name == 'eb_left_turn_within_100_yards') {
            value = inputValue ? inputValue : null;
        }else if (name == 'wb_left_turn_within_100_yards') {
            value = inputValue ? inputValue : null;
        }else if (name == 'FK_median_type_id') {
            if(inputValue === "") 
                setMedianTypeError(true);
            else 
                setMedianTypeError(false);
            value = inputValue ? parseInt(inputValue) : null;
        }else if (name == 'state_roadway') {
            value = inputValue ? inputValue : null;
        }else if (name == 'nb_exclusive_left_turn_lane') {
            value = inputValue ? inputValue : null;
        }else if (name == 'sb_exclusive_left_turn_lane') {
            value = inputValue ? inputValue : null;
        }else if (name == 'eb_exclusive_left_turn_lane') {
            value = inputValue ? inputValue : null;
        }else if (name == 'wb_exclusive_left_turn_lane') {
            value = inputValue ? inputValue : null;
        }else if (name == 'nb_exclusive_right_turn_lane') {
            value = inputValue ? inputValue : null;
        }else if (name == 'sb_exclusive_right_turn_lane') {
            value = inputValue ? inputValue : null;
        }else if (name == 'eb_exclusive_right_turn_lane') {
            value = inputValue ? inputValue : null;
        }else if (name == 'wb_exclusive_right_turn_lane') {
            value = inputValue ? inputValue : null;
        }else if (name == 'one_way_roadway') {
            value = inputValue ? inputValue : null;
        }else if (name == 'auxiliary_lanes') {
            value = inputValue ? inputValue : null;
        }
        else {
            value = inputValue;
        }
        setValues({ ...values, [name]: inputValue, station_location: location, latitude: parseFloat(lat), longitude: parseFloat(long), state_code: region, fips_county_code: county });
        tempValues = { ...values, [name]: inputValue, station_location: location, latitude: parseFloat(lat), longitude: parseFloat(long), state_code: region, fips_county_code: county };
        if (client_station_id_on_display_name){
            setValues({ ...values, display_name: client_station_id_on_display_name});
            tempValues = { ...values, display_name: client_station_id_on_display_name};
        }
    }

    useEffect(() => {
      if(checkedGoogle){
        setMarkerPointer(long,lat)
        setCheckedGoogle(false)
      }
    }, [checkedGoogle])    

    const setMarkerPointer = (longitude, latitude) => {
        loadModules(["esri/geometry/Point", "esri/Graphic", "esri/symbols/PictureMarkerSymbol"], { css: true })
            .then(([Point, Graphic, PictureMarkerSymbol]) => {
                let path = require('../../assets/images/mapPoint.svg');
                tempMapView.graphics.removeAll();
                var point = new Point(longitude, latitude);

                let pointSymbol = {
                    type: "simple-marker",
                    style: "circle",
                    color: "#00b15e",
                    size: 16,
                    outline: {
                        color: "#3676bc",
                        width: 0.5
                    }
                }
                let symbolInt = {
                    type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                    url: require("../../assets/icons/marker_Intersection.png"),
                    width: "42px",
                    height: "42px",
                    yoffset: "20px"
                    };
                    let symbolMid = {
                    type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                    url: require("../../assets/icons/marker_Midblock.png"),
                    width: "42px",
                    height: "42px",
                    yoffset: "20px"
                    };
                    if (station_type==1){
                    pointSymbol=symbolMid;
                    }else{
                    pointSymbol=symbolInt;
                    }
                setMarkerPosition(point); 
                var pointGraphic = new Graphic(point, pointSymbol);
                tempMapView.graphics.add(pointGraphic);
            })
    }

    const setPointer = (longitude, latitude) => {
        loadModules(["esri/geometry/Point", "esri/Graphic", "esri/symbols/PictureMarkerSymbol"], { css: true })
            .then(([Point, Graphic, PictureMarkerSymbol]) => {
                let path = require('../../assets/images/mapPoint.svg');
                tempMapView.graphics.removeAll();
                var point = new Point(parseFloat(longitude), parseFloat(latitude));
                const pointSymbol = {
                    type: "simple-marker",
                    style: "circle",
                    color: "#00b15e",
                    size: 16,
                    outline: {
                        color: "#3676bc",
                        width: 0.5
                    }
                }
                var pointGraphic = new Graphic(point, pointSymbol);
                // let instance = axios.create();
                // delete instance.defaults.headers.common['X-CSRF-TOKEN'];
                // try {
                //     instance({
                //         method: 'GET',
                //         url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&featureTypes=StreetInt, StreetAddress, StreetName&location=' + `${longitude}` + ',' + `${latitude}` + '&token=' + geocodeAcccessToken,

                //     })
                //         .then(async function (response) {
                            
                //             if(response.data.error){
                               
                //                 setLat("");
                //                 setLong("");
                //                 setStationLocation("");
                                
                //                 setRegion("");
                //                 setCounty("");

                //             }else{
                //                 var address = response.data.address;
                //                 setLat(latitude);
                //                 setLong(longitude);
                //                 setStationLocation(address.Match_addr);
                //                 let stateCode = address.LongLabel.split(',');
                            
                //                 let code_station_position=2;
                //                 if(address.Postal!=""){
                //                     code_station_position=3;
                //                     if(address.Postal==address.PlaceName){
                //                         code_station_position=2;
                //                     }
                //                 }
                //                 setRegion(stateCode[stateCode.length-code_station_position]);
                //                 setCounty(address.Subregion);

                //             }
                //             var address = response.data.address;
                //             setLat(latitude);
                //             setLong(longitude);
                //             setStationLocation(address.Match_addr);
                //             let stateCode = address.LongLabel.split(',');
                           
                //             let code_station_position=2;
                //             if(address.Postal!=""){
                //                 code_station_position=3;
                //                 if(address.Postal==address.PlaceName){
                //                     code_station_position=2;
                //                 }
                //             }
                //             setRegion(stateCode[stateCode.length-code_station_position]);
                //             setCounty(address.Subregion);
                //         })
                //         .catch(function (error) {
                //             console.error(error);
                //         })
                // } catch (error) {
                //     console.error(error);
                // }
                tempMapView.graphics.add(pointGraphic);
            })
    }

    const validateForm = async e => {
        e.preventDefault();
        setValues({ ...values, station_location: stationLocation, latitude: lat, longitude: long, state_code: region, fips_county_code: county });
        let tempdata = { ...values, station_location: stationLocation, latitude: parseFloat(lat), longitude: parseFloat(long), state_code: region, fips_county_code: county }
        setErrMsg(null);
        setApproachError(false);
        if (parseInt(values.station_type) === 0 &&
            values.station_location == '' &&
            values.client_station_id == '' &&
            values.latitude == '' &&
            values.longitude == '') {
            setErrMsg('All mandatory fields are required');
            setErrPopUp(true);
        } else if (parseInt(values.station_type) === 0) {
            setErrMsg('Station type required');
            setErrPopUp(true);
        } else if (values.station_location == '') {
            setErrMsg('Location required');
            setErrPopUp(true);
        } else if (values.client_station_id == '') {
            setErrMsg('Station ID required.');
            setErrPopUp(true);
        } else if (values.latitude == '' || values.latitude == null || isNaN(tempdata.latitude)) {
            setErrMsg('Latitude required.');
            setErrPopUp(true);
        } else if (values.longitude == '' || values.longitude == null || isNaN(tempdata.longitude)) {
            setErrMsg('Longitude required.');
            setErrPopUp(true);
        }
        else if (values.speed_limit !== null && isNaN(values.speed_limit) && speedLimitField !== 'none') {
            setErrMsg('Speed Limit Must Be Integer.');
            setErrPopUp(true);
        }
        else {
            let data = tempdata;
            if (data.station_type == 2) {
                let keys = Object.keys(intAllApproaches);
                for (var i = 0; i < keys.length; i++) {
                    var key = (keys[i]);
                    data = { ...data, ...intAllApproaches[key] }
                }
                if (data.eb_approach === '' || data.nb_approach === '' || data.wb_approach === '' || data.sb_approach === '') {
                    setApproachError(true);
                    setErrMsgType('error');
                    setErrMsg('Please select the approaches.');
                    return;
                }
                 // assign lane geometry in case it exists
                if(laneConfigId) {
                    data.FK_lane_config_id = laneConfigId;
                }
            } else if (data.station_type == 1) {
                let keys = Object.keys(midAllApproaches);
                for (var i = 0; i < keys.length; i++) {
                    var key = (keys[i]);
                    data = { ...data, ...midAllApproaches[key] }
                }
                if ( (data.eb_approach !== '' && data.wb_approach === '') || (data.eb_approach === '' && data.wb_approach !== '')
                    || (data.nb_approach !== '' && data.sb_approach === '') || (data.nb_approach === '' && data.sb_approach !== '')
                    || (data.nb_approach === '' && data.sb_approach === '' && data.eb_approach === '' && data.wb_approach === '')
                ) {
                    setApproachError(true);
                    setErrMsgType('error');
                    setErrMsg('Please select the approaches.');
                    return;
                }
                data.enable_los_calculation = losEnabled;
                if(losEnabled) {
                    if (!values.posted_speed_limit) {
                        setErrMsg('Posted speed limit must be integer.');
                        setErrPopUp(true);
                        return 
                    }
                    if(!values.FK_area_classification_id) {
                        setAreaClassError(true);
                        return;
                    }
                    if(!values.FK_median_type_id) {
                        setMedianTypeError(true);
                        return;
                    }
                    if(losDisabledApproaches.length > 0) {
                        for(const it of losDisabledApproaches) {
                            if(values[`${it}_num_lanes`] === "" || !values[`${it}_num_lanes`]) {
                                losDirectionsError.push(it);
                                // setErrMsg('All mandatory fields are required');
                                // setErrPopUp(true);
                                return
                            }
                        }
                    }
                }
            }
            addStation(data);
            
        }
    }

    //This method is use for API call to add new station .... start
    const addStation = (data) => {
        setLoader(true);
        try {
            axios({
                method: 'post',
                data: data,
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.addStationAPI,
            })
                .then(async function (response) {
                    if (response.status && response.status == 200) {
                        //props.stationtabBack();
                        //props.setShowStationDetails(false)
                        setErrMsgType('custom_success')
                        setErrMsg('Saved successfully');
                        setErrPopUp(true)
                        setLoader(false);
                        props.setNeedToReload(true)
                        //add new station to geojson layer                                          
                        updAddNewStation(response.data.data[0]);

                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong1.');
                        setErrPopUp(true)
                        setLoader(false);
                    }
                })
                .catch(async function (error) {
                    if (error.response) {
                        if (error.response.status && error.response.status == '401') {
                            if (Cookies.get('email')) {
                                clearCookie('email');
                                clearCookie('payload');
                                clearCookie('idToken');
                                clearCookie('organization');
                                clearCookie('atexpiry');
                            }
                            history.push('/');
                        } else if (error.response.data && error.response.data.message) {
                            setErrMsgType('error')
                            setErrMsg(error.response.data.message);
                            setErrPopUp(true)
                            setLoader(false);
                        }
                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong2.');
                        setErrPopUp(true)
                        setLoader(false);
                    }
                })
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    }
    //This method is use for API call to add new station .... end

    const clearStationForm = () => {
        tempValues = {
            station_type: 0,
            station_privacy: 1,
            station_location: '',
            display_name: '',
            client_station_id: '',
            status: 'active',
            latitude: 0,
            longitude: 0,
            state_code: '',
            fips_county_code: '',
            jurisdiction: '',
            community: '',
            speed_limit: null,
            FK_functional_classification_code: null,
            FK_primary_purpose: null,
            description: '',
            seasonal_factor_group: '',
            annual_factor_group: '',
            growth_factor_group: '',
            year_station_established: null,
            national_highway_system: null,
            FK_posted_route_signing: null,
            posted_signed_route_number: '',
            nb_approach: '',
            sb_approach: '',
            swb_approach: '',
            seb_approach: '',
            neb_approach: '',
            nwb_approach: '',
            eb_approach: '',
            wb_approach: ''
        };
        setValues({
            station_type: 0,
            station_privacy: 1,
            station_location: '',
            display_name: '',
            client_station_id: '',
            status: 'active',
            latitude: 0,
            longitude: 0,
            state_code: '',
            fips_county_code: '',
            jurisdiction: '',
            community: '',
            speed_limit: 0,
            FK_functional_classification_code: null,
            FK_primary_purpose: null,
            description: '',
            seasonal_factor_group: '',
            annual_factor_group: '',
            growth_factor_group: '',
            year_station_established: null,
            national_highway_system: null,
            FK_posted_route_signing: null,
            posted_signed_route_number: '',
            nb_approach: '',
            sb_approach: '',
            swb_approach: '',
            seb_approach: '',
            neb_approach: '',
            nwb_approach: '',
            eb_approach: '',
            wb_approach: '',
            posted_speed_limit: 0,
            nb_num_lanes: '',
            sb_num_lanes: '',
            eb_num_lanes: '',
            wb_num_lanes: '',
            nb_left_turn_within_100_yards: 'Yes',
            sb_left_turn_within_100_yards: 'Yes',
            eb_left_turn_within_100_yards: 'Yes',
            wb_left_turn_within_100_yards: 'Yes',
            median_type: 'r',
            state_road: 'Yes',
            exclusive_left: 'Yes',
            exclusive_right: 'Yes',
            one_way_roadway: 'Yes',
            auxiliary_lanes: 'Yes',

        });
        setMidAllApproaches({
            approachOne: {},
            approachTwo: {}
        });

        setIntAllApproaches({
            approachOne: {},
            approachTwo: {},
            approachThree: {},
            approachFour: {}
        });

        props.setShowStationDetails(false);

    }

    const homeEvent = () => { // event to go at initial view
        home.go();
        home.on("go", function (event) {
        })
    }
    const ZoomInEvent = () => { // event to zoom in map
        zoom.zoomIn();

    }
    const zoomOutEvent = () => { // event to zoom out map
        zoom.zoomOut();
    }

    //function to select station type
    const selectStationType=(value,name)=>{

        
        setApproachError(false);
        setErrMsg(null);
        // tempValues = { ...values, [name]: parseInt(value) }
        setValues({ ...tempValues, [name]: parseInt(value) });
        
        
        if (parseInt(value) === 2) {
            setLosEnabled(false);
            setInteractionApproch('displayInteraction');
            setMidBlockApproch('hideMidBlock');
            speedLimitField = 'none';
            setValues({...values,
                station_type: 2,  
                FK_area_classification_id: null,       
                posted_speed_limit: null,
                nb_num_lanes: null,
                sb_num_lanes: null,
                eb_num_lanes: null,
                wb_num_lanes: null,
                nb_left_turn_within_100_yards: null,
                sb_left_turn_within_100_yards: null,
                eb_left_turn_within_100_yards: null,
                wb_left_turn_within_100_yards: null,
                FK_median_type_id: null,
                nb_exclusive_left_turn_lane: null,
                sb_exclusive_left_turn_lane: null,
                eb_exclusive_left_turn_lane: null,
                wb_exclusive_left_turn_lane: null,
                nb_exclusive_right_turn_lane: null,
                sb_exclusive_right_turn_lane: null,
                eb_exclusive_right_turn_lane: null,
                wb_exclusive_right_turn_lane: null,
                state_roadway: null,
                one_way_roadway: null,
                auxiliary_lanes: null})
        }
        else {
            setInteractionApproch('hideInteraction');
            setMidBlockApproch('displayMidBlock')
            speedLimitField = '';
            if (parseInt(value) === 0) {
                speedLimitField = 'none';
                setInteractionApproch('hideInteraction');
                setMidBlockApproch('hideMidBlock');
            }
        }

    }

    // This function is for Interaction Approches start
    const showInterractionApproches = (value,name) => {
        let stationType = document.getElementById('station_Type');
        setStationType(stationType.value)
        station_type=stationType.value

        selectStationType(stationType.value,stationType.name)

        //change marker symbol on map 
        loadModules(["esri/geometry/Point", "esri/Graphic"], { css: true })
                .then(([Point, Graphic]) => {
                    let view = tempMapView;
                    let pointSymbol = null;
                        view.graphics.removeAll();                                               
                        let symbolInt = {
                            type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                            url: require("../../assets/icons/marker_Intersection.png"),
                            width: "42px",
                            height: "42px",
                            yoffset: "20px"
                          };
                          let symbolMid = {
                            type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                            url: require("../../assets/icons/marker_Midblock.png"),
                            width: "42px",
                            height: "42px",
                            yoffset: "20px"
                          };
                          if (station_type==1){
                            pointSymbol=symbolMid;
                          }else{
                            pointSymbol=symbolInt;
                          }                       
                        var pointGraphic = new Graphic(markerPosition, pointSymbol);
                        view.graphics.add(pointGraphic);
                })        
    }
     // This function is for Interaction Approches end

     const losDisabledFieldsValidation = (dir) => {
        if(dir !== ""){
            let val = dir.toLowerCase();
            if(val === "nb" || val === "sb") {
                setLosDisabledApproaches(["nb","sb"]);
            } else {
                setLosDisabledApproaches(["eb","wb"]);
            }
        }
    }

    //This function validates the approach dropdowns .... start
    const selectApproach = (e) => {
        setApproachError(false);
        setErrMsg(null);
        setMidApproachSelectOneErr(false);
        setMidApproachSelectTwoErr(false);
        setIntApproachSelectOneErr(false);
        setIntApproachSelectTwoErr(false);
        setIntApproachSelectThreeErr(false);
        setIntApproachSelectFourErr(false);

        losDisabledFieldsValidation(e.target.value);

        let getSelectElement = e.target.id;
        if (getSelectElement == 'intersection_Approaches_select_2') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_1').value == e.target.value || document.getElementById('intersection_Approaches_select_3').value == e.target.value || document.getElementById('intersection_Approaches_select_4').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectTwoErr(true);
            } else {
                if (e.target.value == 'EB') {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { eb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else if (e.target.value == 'NB') {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { nb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else if (e.target.value == 'SB') {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { sb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else if (e.target.value == 'WB') {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { wb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: {} });
                    document.getElementById('intersection_Approaches_text_2').value = '';
                }
            }
        } else if (getSelectElement == 'intersection_Approaches_select_1') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_2').value == e.target.value || document.getElementById('intersection_Approaches_select_3').value == e.target.value || document.getElementById('intersection_Approaches_select_4').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectOneErr(true);
            } else {
                if (e.target.value == 'EB') {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { eb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else if (e.target.value == 'NB') {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { nb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else if (e.target.value == 'SB') {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { sb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else if (e.target.value == 'WB') {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { wb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: {} });
                    document.getElementById('intersection_Approaches_text_1').value = '';
                }
            }
        } else if (getSelectElement == 'intersection_Approaches_select_3') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_2').value == e.target.value || document.getElementById('intersection_Approaches_select_1').value == e.target.value || document.getElementById('intersection_Approaches_select_4').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectThreeErr(true);
            } else {
                if (e.target.value == 'EB') {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { eb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else if (e.target.value == 'NB') {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { nb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else if (e.target.value == 'SB') {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { sb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else if (e.target.value == 'WB') {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { wb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: {} });
                    document.getElementById('intersection_Approaches_text_3').value = '';
                }
            }
        } else if (getSelectElement == 'intersection_Approaches_select_4') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_2').value == e.target.value || document.getElementById('intersection_Approaches_select_3').value == e.target.value || document.getElementById('intersection_Approaches_select_1').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectFourErr(true);
            } else {
                if (e.target.value == 'EB') {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { eb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else if (e.target.value == 'NB') {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { nb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else if (e.target.value == 'SB') {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { sb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else if (e.target.value == 'WB') {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { wb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: {} });
                    document.getElementById('intersection_Approaches_text_4').value = '';
                }
            }
        } else if (getSelectElement == 'mid_Approaches_select_1') {
            let changeSelect = document.getElementById('mid_Approaches_select_2');
            if (document.getElementById('mid_Approaches_select_2').value == '' || document.getElementById('mid_Approaches_select_1').length == 5){
                document.getElementById('mid_Approaches_text_2').value = '';
                setMidAllApproaches({ ...midAllApproaches, ...midAllApproaches.approachTwo = {} });
                while (changeSelect.length > 0) {
                    changeSelect.remove(0);
                }
            }
            if (e.target.value == 'EB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { eb_approach: document.getElementById('mid_Approaches_text_1').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'WB';
                opt2.innerHTML = 'WB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { wb_approach: document.getElementById('mid_Approaches_text_1').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'EB';
                opt2.innerHTML = 'EB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == 'NB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { nb_approach: document.getElementById('mid_Approaches_text_1').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'SB';
                opt2.innerHTML = 'SB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == 'SB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { sb_approach: document.getElementById('mid_Approaches_text_1').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'NB';
                opt2.innerHTML = 'NB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == '') {
                document.getElementById('mid_Approaches_text_1').value = '';
                setMidAllApproaches({ ...midAllApproaches, approachOne: {} });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'EB';
                opt2.innerHTML = 'EB';
                changeSelect.appendChild(opt2);
                let opt3 = document.createElement('option');
                opt3.value = 'NB';
                opt3.innerHTML = 'NB';
                changeSelect.appendChild(opt3);
                let opt4 = document.createElement('option');
                opt4.value = 'SB';
                opt4.innerHTML = 'SB';
                changeSelect.appendChild(opt4);
                let opt5 = document.createElement('option');
                opt5.value = 'WB';
                opt5.innerHTML = 'WB';
                changeSelect.appendChild(opt5);
            }
        } else if (getSelectElement == 'mid_Approaches_select_2') {
            let changeSelect = document.getElementById('mid_Approaches_select_1');
            if (document.getElementById('mid_Approaches_select_1').value == '' || document.getElementById('mid_Approaches_select_2').length == 5){
                document.getElementById('mid_Approaches_text_1').value = '';
                setMidAllApproaches({ ...midAllApproaches, ...midAllApproaches.approachOne = {} });
                while (changeSelect.length > 0) {
                    changeSelect.remove(0);
                }
            }
            if (e.target.value == 'EB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { eb_approach: document.getElementById('mid_Approaches_text_2').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'WB';
                opt2.innerHTML = 'WB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == 'WB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { wb_approach: document.getElementById('mid_Approaches_text_2').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'EB';
                opt2.innerHTML = 'EB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == 'NB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { nb_approach: document.getElementById('mid_Approaches_text_2').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'SB';
                opt2.innerHTML = 'SB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == 'SB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { sb_approach: document.getElementById('mid_Approaches_text_2').value } });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'NB';
                opt2.innerHTML = 'NB';
                changeSelect.appendChild(opt2);
            } else if (e.target.value == '') {
                document.getElementById('mid_Approaches_text_2').value = '';
                setMidAllApproaches({ ...midAllApproaches, approachTwo: {} });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'EB';
                opt2.innerHTML = 'EB';
                changeSelect.appendChild(opt2);
                let opt3 = document.createElement('option');
                opt3.value = 'NB';
                opt3.innerHTML = 'NB';
                changeSelect.appendChild(opt3);
                let opt4 = document.createElement('option');
                opt4.value = 'SB';
                opt4.innerHTML = 'SB';
                changeSelect.appendChild(opt4);
                let opt5 = document.createElement('option');
                opt5.value = 'WB';
                opt5.innerHTML = 'WB';
                changeSelect.appendChild(opt5);
            }
        }
    }
    //This function validates the approach dropdowns .... end
   
    //This function validates the approach texts ... start
    const approachText = (e) => { 
        setApproachError(false);
        setErrMsg(null);
        let value= e.target.value.trim() 
        let getTextElement = e.target.id;
        if (getTextElement == 'intersection_Approaches_text_1') {
            if(value==''){
               
                aproachDetailsError[0]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                
                aproachDetailsError[0]=false
               
            }
            if (document.getElementById('intersection_Approaches_select_1').value == 'EB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { eb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_1').value == 'NB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { nb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_1').value == 'SB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { sb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_1').value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachOne: { wb_approach: e.target.value } });
            } else {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Select approach.');
                setIntApproachSelectOneErr(true);
            }
        } else if (getTextElement == 'intersection_Approaches_text_2') {
            if(value==''){
               
                aproachDetailsError[1]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                
                aproachDetailsError[1]=false
               
            }
            if (document.getElementById('intersection_Approaches_select_2').value == 'EB') {
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { eb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_2').value == 'NB') {
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { nb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_2').value == 'SB') {
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { sb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_2').value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { wb_approach: e.target.value } });
            } else {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Select approach.');
                setIntApproachSelectTwoErr(true);
            }
        } else if (getTextElement == 'intersection_Approaches_text_3') {
            if(value==''){
               
                aproachDetailsError[2]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                
                aproachDetailsError[2]=false
               
            }
            if (document.getElementById('intersection_Approaches_select_3').value == 'EB') {
                setIntAllApproaches({ ...intAllApproaches, approachThree: { eb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_3').value == 'NB') {
                setIntAllApproaches({ ...intAllApproaches, approachThree: { nb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_3').value == 'SB') {
                setIntAllApproaches({ ...intAllApproaches, approachThree: { sb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_3').value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachThree: { wb_approach: e.target.value } });
            } else {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Select approach.');
                setIntApproachSelectThreeErr(true);
            }
        } else if (getTextElement == 'intersection_Approaches_text_4') {
            if(value==''){
               
                aproachDetailsError[3]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                
                aproachDetailsError[3]=false
               
            }
            if (document.getElementById('intersection_Approaches_select_4').value == 'EB') {
                setIntAllApproaches({ ...intAllApproaches, approachFour: { eb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_4').value == 'NB') {
                setIntAllApproaches({ ...intAllApproaches, approachFour: { nb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_4').value == 'SB') {
                setIntAllApproaches({ ...intAllApproaches, approachFour: { sb_approach: e.target.value } });
            } else if (document.getElementById('intersection_Approaches_select_4').value == 'WB') {
                setIntAllApproaches({ ...intAllApproaches, approachFour: { wb_approach: e.target.value } });
            } else {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Select approach.');
                setIntApproachSelectFourErr(true);
            }
        } else if (getTextElement == 'mid_Approaches_text_2') {
            if(value==''){
               
                aproachDetailsErrorMid[1]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                
                aproachDetailsErrorMid[1]=false
               
            }
            if (document.getElementById('mid_Approaches_select_2').value == 'EB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { eb_approach: e.target.value } });
            } else if (document.getElementById('mid_Approaches_select_2').value == 'NB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { nb_approach: e.target.value } });
            } else if (document.getElementById('mid_Approaches_select_2').value == 'SB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { sb_approach: e.target.value } });
            } else if (document.getElementById('mid_Approaches_select_2').value == 'WB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { wb_approach: e.target.value } });
            } else {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Select approach.');
                setMidApproachSelectTwoErr(true);
            }
        } else if (getTextElement == 'mid_Approaches_text_1') {
            if(value==''){
               
                aproachDetailsErrorMid[0]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                
                aproachDetailsErrorMid[0]=false
               
            }
            if (document.getElementById('mid_Approaches_select_1').value == 'EB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { eb_approach: e.target.value } });
            } else if (document.getElementById('mid_Approaches_select_1').value == 'NB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { nb_approach: e.target.value } });
            } else if (document.getElementById('mid_Approaches_select_1').value == 'SB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { sb_approach: e.target.value } });
            } else if (document.getElementById('mid_Approaches_select_1').value == 'WB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { wb_approach: e.target.value } });
            } else {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Select approach.');
                setMidApproachSelectOneErr(true);
            }
        }
    }
    //This function validates the approach texts ... end
    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const handleScroll = () => {
        if (mainBgRef.current) {
          const { scrollTop } = mainBgRef.current;
          if (scrollTop > 0) {
            setScrolled(true);
          } else {
            setScrolled(false);
          }
        }
     }; 

    const handleEnableLOS = () => {
        let tmpDis = [];
        if(Object.keys(midAllApproaches).length > 0) {
            let one = Object.keys(midAllApproaches.approachOne).length > 0 ? Object.keys(midAllApproaches.approachOne)[0] : "";
            let two = Object.keys(midAllApproaches.approachTwo).length > 0 ? Object.keys(midAllApproaches.approachTwo)[0] : "";
            tmpDis.push(one.replace("_approach", ""));
            tmpDis.push(two.replace("_approach", ""));
        }
        setLosDisabledApproaches(tmpDis);
        if(losEnabled) {
            setValues({...values,  
                FK_area_classification_id: null,       
                posted_speed_limit: null,
                nb_num_lanes: null,
                sb_num_lanes: null,
                eb_num_lanes: null,
                wb_num_lanes: null,
                nb_left_turn_within_100_yards: null,
                sb_left_turn_within_100_yards: null,
                eb_left_turn_within_100_yards: null,
                wb_left_turn_within_100_yards: null,
                FK_median_type_id: null,
                nb_exclusive_left_turn_lane: null,
                sb_exclusive_left_turn_lane: null,
                eb_exclusive_left_turn_lane: null,
                wb_exclusive_left_turn_lane: null,
                nb_exclusive_right_turn_lane: null,
                sb_exclusive_right_turn_lane: null,
                eb_exclusive_right_turn_lane: null,
                wb_exclusive_right_turn_lane: null,
                state_roadway: null,
                one_way_roadway: null,
                auxiliary_lanes: null})
        } else {
            setValues({...values,  
                FK_area_classification_id: null,       
                posted_speed_limit: null,
                nb_num_lanes: null,
                sb_num_lanes: null,
                eb_num_lanes: null,
                wb_num_lanes: null,
                nb_left_turn_within_100_yards: 'Yes',
                sb_left_turn_within_100_yards: 'Yes',
                eb_left_turn_within_100_yards: 'Yes',
                wb_left_turn_within_100_yards: 'Yes',
                FK_median_type_id: null,
                nb_exclusive_left_turn_lane: 'Yes',
                sb_exclusive_left_turn_lane: 'Yes',
                eb_exclusive_left_turn_lane: 'Yes',
                wb_exclusive_left_turn_lane: 'Yes',
                nb_exclusive_right_turn_lane: 'Yes',
                sb_exclusive_right_turn_lane: 'Yes',
                eb_exclusive_right_turn_lane: 'Yes',
                wb_exclusive_right_turn_lane: 'Yes',
                state_roadway: 'Yes',
                one_way_roadway: 'Yes',
                auxiliary_lanes: 'Yes'})

        }
        setLosEnabled(!losEnabled);
    }


    return (
        <React.Fragment>  
        <CssBaseline />
            <div className="management-main">
                <Container className="station-management-container" maxWidth="lg">
                <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => validateForm(e)} data-testid='station_details_from'>
                    <AppBar position="static" color="default" className={(scrolled?'table-scrolled':'') + ' tabs-header station-tabs' }>
                        <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                        >
                            <Tab label="Add station" {...a11yProps(0)} id="userTabb" data-testid="userListTab" className={'main_panel_title'}  style={{ maxWidth:'110px !important'}}/>
                            
                        </Tabs>
                        <div className="add-user-cnt">
                           
                            <img src={require('../../assets/icons/close.svg')} onClick={() => props.setShowStationDetails(false)} />
                        </div>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={value}
                        onChangeIndex={handleChangeIndex}
                        className={'main_bg'}
                    >
                        <TabPanel value={value} index={0} dir={theme.direction} >
                      
                        <div>
                        <div className="stations-detail-content ddd "
                         onScroll={handleScroll}
                         ref={mainBgRef} >
                        {errMsg ? <div className={'approachError'} >  <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div> : null}
                            <div className={'station_container'}
                            >
                          
                                <div className={'station_container_row'}>
                                    <div className="station_card_info m-r-16">
                                        <Autocomplete
                                            className={'general-text-input'}
                                            style={{width:'100%'}}
                                            apiKey={process.env.REACT_APP_MAPS_KEY}
                                            onPlaceSelected={async (place) => {
                                                const latitudeLocal = place.geometry.location.lat();
                                                const longitudeLocal = place.geometry.location.lng();
                                                setLat(latitudeLocal);
                                                setStationLatitudeError(false)
                                                setLong(longitudeLocal);
                                                setStationLongitudeError(false)
                                                setCheckedGoogle(true)

                                                const components = place.address_components;
                                                let locality = "";
                                                let state = "";
                                                let county = "";


                                                components.forEach((component) => {
                                                    const componentTypes = component.types;
                                                    
                                                      if (componentTypes.includes("administrative_area_level_1")) {
                                                        state = component.short_name;
                                                      }
                                                    
                                                      if (componentTypes.includes("country")) {
                                                        county = component.short_name;
                                                      }

                                                      if (componentTypes.includes("locality")) {
                                                        locality = component.long_name;
                                                      }
                                                });
                                                if(locality && state && county){
                                                    setValues({ ...values, station_location: `${locality}, ${state}, ${county}`, latitude: parseFloat(latitudeLocal), longitude: parseFloat(longitudeLocal) });
                                                    tempValues = { ...tempValues,station_location: `${locality}, ${state}, ${county}`, latitude: parseFloat(latitudeLocal), longitude: parseFloat(longitudeLocal) };
                                                    setStationLocation(`${locality}, ${state}, ${county}`)
                                                    setStationLocationError(false)
                                                }else{
                                                    setValues({ ...values, latitude: parseFloat(latitudeLocal), longitude: parseFloat(longitudeLocal) });
                                                    tempValues = { ...tempValues, latitude: parseFloat(latitudeLocal), longitude: parseFloat(longitudeLocal) };
                                                }
                                                if(state){
                                                    setRegion(state)
                                                }
                                                if(county){
                                                    setCounty(county)
                                                }
                                                
                                            }}  
                                        />
                                        <div className={'station_card_title'} style={{ marginTop: '16px' }}>
                                        General Info  
                                        </div>
                                        <div className={'station_card_content'}>
                                            <div>
                                                <div className='station-detail-row'>
                                                    <div className='station-detail-child m-r-16'>
                                                        <label className={'general-label label_input_station'}>Station type</label>
                                                        <select id="station_Type" 
                                                        name="station_type" 
                                                        data-testid='station_type' 
                                                        value={stationType}
                                                        className={'general-text-input'} onChange={showInterractionApproches}>
                                                        
                                                        {stationTypeValue.length > 0 ?
                                                            stationTypeValue.map((value, index) => {
                                                                return <option value={value.id}>{value.station_type}</option>
                                                            })
                                                            : null
                                                        }                                                
                                                    </select>  
                                                    </div>
                                                    <div className='station-detail-child'>
                                                        <label className={'general-label label_input_station'}>Station privacy</label>
                                                        <select id="station_Privacy" 
                                                        name="station_privacy" 
                                                        data-testid='station_privacy' 
                                                        className={'general-text-input'} 
                                                        onChange={handleChange('station_privacy')}>
                                                            <option value={1}>Public</option>
                                                            <option value={2}>Private</option>
                                                        </select>

                                                    </div>
                                                

                                                </div>
                                                <div className='station-detail-row'>
                                                <div className='station-detail-child'>
                                                        <label className={'general-label label_input_station'}>Station location</label>
                                                        
                                                        <FilledInput id="station_location" 
                                                        name="station_location" 
                                                        data-testid='station_location' 
                                                        
                                                        className={stationLocationError ? "form-text-input-error" : "form-text-input"} 
                                                        endAdornment={ stationLocationError && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                        style={{width:'448px'}} 
                                                         type="text" variant="outlined" value={stationLocation} required onChange={handleChange('station_location')} />
                                                         {stationLocationError ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                    </div>
                                                  
                                                </div>
                                                <div className='station-detail-row'>
                                                    <div className='station-detail-child'>
                                                        <label  className={'general-label label_input_station'}>Station names</label>
                                                        <FilledInput id="display_Name" 
                                                        name="display_Name" 
                                                        data-testid='display_name' 
                                                        className={displayNameError ? "form-text-input-error" : "form-text-input"} 
                                                        endAdornment={ displayNameError && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                         
                                                        style={{width:'448px'}} 
                                                        
                                                        type="text" variant="outlined" onChange={handleChange('display_name')} />
                                                         {displayNameError ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                        </div>
                                                    </div>
                                        
                                                </div>
                                               
                                                
                                        
                                        </div>

                                    </div>
                                    <div className="station_card_info_right">
                                        <div className={'station_card_title'}>
                                        Map 
                                        </div>
                                        <div className={'station_card_content_right'} style={{height: '278px'}}>
                                            <div>
                                           
                                            <div className={classes.locationMapView}>
                                                <div ref={mapRef} className={classes.mapContainer} data-testid='mapView'>
                                                    <Box display='flex' flexDirection="column" className={classes.iconBox}>
                                                    <div className={'homeIcon'} title="Home" >
                                                            <img src={require('../../assets/icons/map/Home.png')} style={{width:'20px', height:'20px'}} onClick={() => homeEvent()} title="Home" />
                                                                
                                                            </div>
                                                            <div className={'zoomIcon'} style={{ marginBottom: '-3px' }} title="Zoom In">
                                                            <img src={require('../../assets/icons/map/Add.png')}  style={{width:'20px', height:'20px'}} onClick={() => ZoomInEvent()} title="Zoom In" />
                                                               
                                                            </div>
                                                            <div className={'inIcon'} title="Zoom Out">
                                                            <img src={require('../../assets/icons/map/Minus.png')}   style={{width:'20px', height:'20px'}} onClick={() => zoomOutEvent()} title="Zoom Out"/>
                                                               
                                                            </div>
                                                             {/* This Code Just Information to click    */}
                                                            <div className={'r-click-map'}>Right-click to add a station</div>
                                                            {/* This Code Just Information to click    */}
                                                    </Box>
                                                </div>
                                            </div>
                                            </div>
                                        
                                        </div>

                                    </div>

                                </div>

                                <div className={'station_container_row'}>
                                    <div className="station_card_info m-r-16">
                                        <div className={'station_card_title'}>
                                        Details & location 
                                        </div>
                                        <div className={'station_card_content'} style={{minHeight: '328px'}}>
                                                <div className='station-detail-row'>
                                                    <div className='station-detail-child m-r-16'>
                                                        <label className={'general-label label_input_station'}>Station ID</label>
                                                        <FilledInput 
                                                        id="station_id" 
                                                        name="client_station_id" 
                                                        data-testid='client_station_id' 
                                                        className={stationIdError ? "form-text-input-error" : "form-text-input"} 
                                                        endAdornment={ stationIdError && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                       value={stationId}
                                                        type="text" 
                                                        variant="outlined" 
                                                        required 
                                                        onChange={handleChange('client_station_id')} />
                                                         {stationIdError ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                    </div>
                                                    <div className='station-detail-child'>
                                                        <label className={'general-label label_input_station'}>Status</label>
                                                        <select 
                                                        id="status_check" 
                                                        name="status" 
                                                        data-testid='status' 
                                                        className={'general-text-input'} 
                                                        onChange={handleChange('status')}>
                                                            <option value="active">Active</option>
                                                            <option value="inactive">Inactive</option>
                                                        </select>
                                                    </div>
                                                

                                                </div>
                                                <div className='station-detail-row'>
                                                    <div className='station-detail-child m-r-16'>
                                                        <label className={'general-label label_input_station'}>Latitude</label>
                                                        <FilledInput 
                                                        id="latitude" 
                                                        name="latitude" 
                                                        data-testid='latitude' 
                                                        className={stationLatitudeError ? "form-text-input-error" : "form-text-input"} 
                                                        endAdornment={ stationLatitudeError && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                      
                                                        type="text" 
                                                        variant="outlined" 
                                                        value={lat!=""?parseFloat(lat).toFixed(6):""} required
                                                         onChange={handleChange('latitude')} />
                                                         {stationLatitudeError ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                    </div>
                                                    <div className='station-detail-child'>
                                                        <label className={'general-label label_input_station'}>Longitude</label>
                                                        <FilledInput 
                                                        id="longitude" 
                                                        name="longitude" 
                                                        data-testid='longitude' 
                                                        className={stationLatitudeError ? "form-text-input-error" : "form-text-input"} 
                                                        endAdornment={ stationLatitudeError && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                     
                                                        type="text" 
                                                        variant="outlined" 
                                                        value={long!=""?parseFloat(long).toFixed(6):""} required onChange={handleChange('longitude')} />
                                                         {stationLongitudeError ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                    </div>
                                                

                                                </div>
                                                <div className='station-detail-row'>
                                                    <div className='station-detail-child m-r-16'>
                                                        <label className={'general-label label_input_station'}>State</label>
                                                        <TextField 
                                                        id="state_code" 
                                                        name="state_code" 
                                                        data-testid='state_code' 
                                                        className={'form-text-input'} 
                                                        style={{width:'48px'}}  
                                                        disabled
                                                        type="text" 
                                                        variant="outlined" 
                                                        value={region.trim()} required onChange={handleChange('state_code')} />
                                                    </div>
                                                    <div className='station-detail-child m-r-16'>
                                                        <label className={'general-label label_input_station'}>County</label>
                                                        <TextField 
                                                        id="county" 
                                                        name="fips_county_code" 
                                                        data-testid="fips_county_code" 
                                                        style={{width:'216px'}} 
                                                        className={'form-text-input txt-gray-700'}
                                                        disabled
                                                        type="text" 
                                                        variant="outlined" 
                                                        value={county} onChange={handleChange('fips_county_code')} /> 
                                                    </div>
                                                    <div className='station-detail-child'>
                                                        <div className='optional-cnt'>
                                                            <label className={'general-label label_input_station'}>Speed limit</label>
                                                            <span class="station-text1">Optional</span>
                                                        </div>
                                                        <TextField id="speed_Limit" 
                                                        name="speed_Limit" 
                                                        data-testid="speed_limit" 
                                                        className={'form-text-input txt-gray-700'}
                                                     
                                                        type="tel" 
                                                        variant="outlined" 
                                                        onChange={handleChange('speed_limit')} 
                                                        style={{width:'152px'}}
                                                         />
                                                        
                                                    </div>
                                                

                                                </div>
                                                <div className='station-detail-row'>
                                                    <div className='station-detail-child m-r-16'>
                                                        <div className='optional-cnt'>
                                                            <label className={'general-label'}>Jurisdiction</label>
                                                            <span class="station-text1">Optional</span>
                                                        </div>
                                                        <TextField id="jurisdiction"
                                                          style={{width:'208px'}}  
                                                        name="jurisdiction" 
                                                        data-testid="jurisdiction" 
                                                        className={'form-text-input'}  type="text" variant="outlined" onChange={handleChange('jurisdiction')}>
                                                        </TextField>
                                                        
                                                    
                                                    </div>
                                                    <div className='station-detail-child'>
                                                        <div className='optional-cnt'>
                                                            <label className={'general-label'}>Community</label>
                                                            <span class="station-text1">Optional</span>
                                                        </div>
                                                        <TextField 
                                                         style={{width:'224px'}}  
                                                        id="community" 
                                                        name="community" 
                                                        data-testid="community" 
                                                        className={'form-text-input'} 
                                                         type="text" variant="outlined" onChange={handleChange('community')} />
                                                    </div>
                                                

                                                </div>
                                                
                                            <div>

                                            </div>
                                        
                                        </div>

                                        <div className='pnl-main-miscellaneous'>
                                            <label>Miscellaneous</label>
                                            <div className='pnl-main-miscellaneous-card'>
                                                <textarea onChange={handleChange('miscellaneous')} ></textarea>                    
                                            </div>
                                        </div>

                                    </div>
                                    <div className="station_card_info_right">
                                        <div className={'station_card_title'}>
                                        Approaches 
                                        </div>
                                        <div className={'station_card_content_right'}  >
                                            <div>
                                            <div className={midBlockApproch}>
                                               
                                                  
                                                    {approachError ? <div className={classes.approachError}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={approachError} msgType={errMsgType} /></div> : null}
                                                    <div className={classes.interApprochMainBlock}>
                                                    <div className='station-detail-row'>
                                                    
                                                        <div className="station-detail-childt" >
                                                                <label className={'general-label'}>Direction</label>
                                                                <select
                                                                IconComponent={ExpandMoreIcon}
                                                                id="mid_Approaches_select_1" 
                                                                            name="mid_Approaches_select_1" 
                                                                    data-testid="mid_Approaches_select_1" 
                                                                    className={' general-text-input select-ap'}  
                                                                    style={{width:'88px'}}  
                                                                    onChange={selectApproach}>
                                                                        <option value="">Select</option>
                                                                        <option value="EB">EB</option>
                                                                        <option value="NB">NB</option>
                                                                        <option value="SB">SB</option>
                                                                        <option value="WB">WB</option>
                                                                </select>
                                                            
                                                        </div>
                                                        <div className="station-detail-childt" >
                                                            <label className={'general-label'}>Details</label>
                                                            <FilledInput id="mid_Approaches_text_1" 
                                                            name="mid_Approaches_text_1" 
                                                            style={{width:'336px'}} 
                                                            className={aproachDetailsErrorMid[0] ? "form-text-input-error" : "form-text-input"} 
                                                            endAdornment={ aproachDetailsErrorMid[0] && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                         
                                                            type="text" 
                                                            variant="outlined" onChange={approachText} data-testid="mid_Approaches_text_1" />
                                                            {aproachDetailsErrorMid[0] ? <p className="form-error-label">{formErrorMessage}</p> : null}

                                                        </div>    
                                                    </div>
                                                    <div className='station-detail-row'>
                                                    
                                                    <div className="station-detail-childt" >
                                                            <label className={'general-label'}>Direction</label>
                                                            <select
                                                            IconComponent={ExpandMoreIcon}
                                                            id="mid_Approaches_select_2" 
                                                            name="mid_Approaches_select_2" 
                                                            style={{width:'88px'}}  
                                                            className={' general-text-input select-ap'}  
                                                            onChange={selectApproach} data-testid="mid_Approaches_select_2">
                                                                <option value="">Select</option>
                                                                <option value="EB">EB</option>
                                                                <option value="NB">NB</option>
                                                                <option value="SB">SB</option>
                                                                <option value="WB">WB</option>
                                                            </select>
                                                        
                                                    </div>
                                                    <div className="station-detail-childt" >
                                                        <label className={'general-label'}>Details</label>
                                                        <FilledInput 
                                                        id="mid_Approaches_text_2"  
                                                        style={{width:'336px'}}  
                                                        name="mid_Approaches_text_2" 
                                                        
                                                        className={aproachDetailsErrorMid[1] ? "form-text-input-error" : "form-text-input"} 
                                                        endAdornment={ aproachDetailsErrorMid[1] && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                      
                                                        type="text" 
                                                        variant="outlined" 
                                                        onChange={approachText} data-testid="mid_Approaches_text_2" />
                                                         {aproachDetailsErrorMid[1] ? <p className="form-error-label">{formErrorMessage}</p> : null}

                                                    </div>    
                                                </div>    

                                                      
                                                    </div>
                                                  
                                                
                                            </div>
                                            {/* -------------------------------------------------- */}
                                            <div className={interactionApproch}>
                                            {approachError ? <div className={classes.approachError}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={approachError} msgType={errMsgType} /> </div> : null}
                                                 
                                                    <div className='station-detail-row'>    
                                                                <div className="station-detail-childt">
                                                                    <label className={'general-label'}>Direction</label>
                                                                    <select
                                                                    IconComponent={ExpandMoreIcon}
                                                                    id="intersection_Approaches_select_1" 
                                                                    data-testid="intersection_Approaches_select_1" 
                                                                    name="intersection_Approaches_select_1" 
                                                                    className={' general-text-input select-ap'}  
                                                                    style={{width:'88px'}}  
                                                                                      
                                                                    onChange={selectApproach}>
                                                                       
                                                                        <option value="">Select</option>
                                                                        <option value="EB">EB</option>
                                                                        <option value="NB">NB</option>
                                                                        <option value="SB">SB</option>
                                                                        <option value="WB">WB</option>
                                                                       
                                                                    </select>
                                                                </div>
                                                                <div className="station-detail-childt">
                                                                    <label className={'general-label'}>Details</label>
                                                                    <FilledInput id="intersection_Approaches_text_1"  
                                                                    style={{width:'336px'}}  
                                                                    name="intersection_Approaches_text_1" 
                                                                    
                                                                    className={aproachDetailsError[0] ? "form-text-input-error" : "form-text-input"} 
                                                                    endAdornment={ aproachDetailsError[0] && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                                  
                                                                  
                                                                    type="text" 
                                                                    variant="outlined" 
                                                                    onChange={approachText} data-testid="intersection_Approaches_text_1" />
                                                                    {aproachDetailsError[0] ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                                </div>  
                                                    </div>  
                                                    <div className='station-detail-row'>    
                                                                <div className="station-detail-childt">
                                                                    <label className={'general-label'}>Direction</label>
                                                                    <select
                                                                    IconComponent={ExpandMoreIcon}
                                                                    id="intersection_Approaches_select_2"  
                                                                    name="intersection_Approaches_select_2" 
                                                                    className={' general-text-input select-ap'}
                                                                    style={{width:'88px'}}  
                                                                    onChange={selectApproach} data-testid="intersection_Approaches_select_2">
                                                                        <option value="">Select</option>
                                                                        <option value="EB">EB</option>
                                                                        <option value="NB">NB</option>
                                                                        <option value="SB">SB</option>
                                                                        <option value="WB">WB</option>
                                                                    </select>
                                                                </div>
                                                                <div className="station-detail-childt">
                                                                    <label className={'general-label'}>Details</label>
                                                                    <FilledInput 
                                                                    id="intersection_Approaches_text_2"  
                                                                    style={{width:'336px'}}  name="intersection_Approaches_text_2" 
                                                                    className={aproachDetailsError[1] ? "form-text-input-error" : "form-text-input"} 
                                                                    endAdornment={ aproachDetailsError[1] && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                                  
                                                                    type="text" variant="outlined" 
                                                                    onChange={approachText} data-testid="intersection_Approaches_text_2" />
                                                                    {aproachDetailsError[1] ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                                </div>  
                                                    </div> 
                                                    <div className='station-detail-row'>    
                                                                <div className="station-detail-childt">
                                                                    <label className={'general-label'}>Direction</label>
                                                                    <select
                                                                    IconComponent={ExpandMoreIcon}
                                                                    id="intersection_Approaches_select_3" 
                                                                    name="intersection_Approaches_select_3" 
                                                                    style={{width:'88px'}}  
                                                                    className={' general-text-input' } 
                                                                    onChange={selectApproach} data-testid="intersection_Approaches_select_3">
                                                                        <option value="">Select</option>
                                                                        <option value="EB">EB</option>
                                                                        <option value="NB">NB</option>
                                                                        <option value="SB">SB</option>
                                                                        <option value="WB">WB</option>
                                                                    </select>
                                                                </div>
                                                                <div className="station-detail-childt">
                                                                    <label className={'general-label'}>Details</label>
                                                                    <FilledInput   
                                                                    style={{width:'336px'}}  
                                                                    id="intersection_Approaches_text_3" 
                                                                    name="intersection_Approaches_text_3" 
                                                                    className={aproachDetailsError[2] ? "form-text-input-error" : "form-text-input"} 
                                                                    endAdornment={ aproachDetailsError[2] && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                                
                                                                    type="text" 
                                                                    variant="outlined" 
                                                                    onChange={approachText} data-testid="intersection_Approaches_text_3" />
                                                                     {aproachDetailsError[2] ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                                </div>  
                                                    </div> 

                                                     <div className='station-detail-row'>    
                                                                <div className="station-detail-childt">
                                                                    <label className={'general-label'}>Direction</label>
                                                                    <select
                                                                    IconComponent={ExpandMoreIcon}
                                                                    id="intersection_Approaches_select_4" 
                                                                    name="intersection_Approaches_select_4" 
                                                                    style={{width:'88px'}}  
                                                                    className={' general-text-input'} 
                                                                    onChange={selectApproach} data-testid="intersection_Approaches_select_4">
                                                                        <option value="">Select</option>
                                                                        <option value="EB">EB</option>
                                                                        <option value="NB">NB</option>
                                                                        <option value="SB">SB</option>
                                                                        <option value="WB">WB</option>
                                                                    </select>
                                                                </div>
                                                                <div className="station-detail-childt">
                                                                    <label className={'general-label'}>Details</label>
                                                                    <FilledInput   
                                                                    style={{width:'336px'}}  
                                                                    id="intersection_Approaches_text_4" 
                                                                    name="intersection_Approaches_text_4"
                                                                    className={aproachDetailsError[3] ? "form-text-input-error" : "form-text-input"} 
                                                                    endAdornment={ aproachDetailsError[3] && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                                
                                                                    type="text" 
                                                                     variant="outlined" onChange={approachText} 
                                                                     data-testid="intersection_Approaches_text_4" />
                                                                     {aproachDetailsError[3] ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                                </div>  
                                                    </div>  
                                                  
                                                    
                                                 
                                               
                                            </div>
                                           
                                            </div>
                                        
                                        </div>
                                        {
                                            station_type == 2 &&
                                            <div className='pnl-main-lane'>
                                                <label>Lane geometry</label>
                                                <div className='pnl-main-lane-card'>
                                                    <label>Configure this stations lane geometry using our geometry configurator by pressing the button below.</label>
                                                    <div>
                                                        <div className={laneConfigId ? 'geometry-cnt geometry-set' : 'geometry-cnt no-geometry-set'}>
                                                            <label className='geometry-set-indicator'></label>
                                                            <label>{laneConfigId ? 'Geometry set': 'No geometry set'}</label>
                                                        </div>
                                                        <div className="geometry-link" style={(lat === "" || long === "") ? {pointerEvents: 'none'} : null} onClick={() => setShowLaneConfig(true)} disabled={lat === "" || long === ""}>
                                                            <label>Lane geometry configurator</label>
                                                            <img src={require('../../assets/icons/external_link.svg')} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {
                                            station_type == 1 &&
                                            <div className="station_card_info m-r-16">
                                                <div className={'station_card_title'}>
                                                    <Checkbox checked={losEnabled} onChange={handleEnableLOS} />Enable Level of Service (LOS) calculations 
                                                </div>
                                                {
                                                    losEnabled &&
                                                    <div className={'station_card_content_right'} >
                                                        {!losEnabled && (<div style={{position:'absolute', top:0, left:0, width:'100%', height: '100%', backgroundColor:'rgba(0, 0, 0, 0.03)', pointerEvents:'none',zIndex:1}}></div> )}
                                                        <div>
                                                        <div className={midBlockApproch}>
                                                                {approachError ? <div className={classes.approachError}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={approachError} msgType={errMsgType} /></div> : null}
                                                                <div className={classes.interApprochMainBlock}>
                                                                <div className='station-detail-row'>
                                                                
                                                                    <div className="station-detail-childt" style={{width: '100%'}}>
                                                                            <div style={{display:'flex', alignItems:'center'}}>
                                                                                <label className={'general-label'}>Area classification</label>
                                                                                <div onClick={()=>setShowLOS(!showLOS)} style={{background:'#717171', height:'20px', width: '20px', borderRadius: '50px', display:'flex', justifyContent:'center', alignItems:'center', marginLeft: '5px', cursor: 'pointer'}}><FontAwesomeIcon icon={faQuestion} style={{color: "white",width:'0.45em'}} /></div>
                                                                            </div>
                                                                            <div style={{width: '100%'}}>
                                                                                <select 
                                                                                    id="state_road_select" 
                                                                                    name="state_road_select" 
                                                                                    style={{width:'440px'}}  
                                                                                    className={areaClassError ? "general-text-input error" : "general-text-input"} 
                                                                                    onChange={handleChange('FK_area_classification_id')}
                                                                                >
                                                                                    <option value="">Select an area classification</option>
                                                                                {areaClassifications.map(item=>(
                                                                                    <option value={item['id']}>{item['name']} - {item['code']}</option>
                                                                                ))}
                                                                                </select>
                                                                            </div>
                                                                    </div>  
                                                                </div>

                                                                <div className='station-detail-row'>    
                                                                            <div className="station-detail-childt">
                                                                                <label className={'general-label'}>State road</label>
                                                                                <select
                                                                                IconComponent={ExpandMoreIcon}
                                                                                id="state_road_select" 
                                                                                name="state_road_select" 
                                                                                style={{width:'88px'}}  
                                                                                className={' general-text-input' } 
                                                                                onChange={handleChange('state_roadway')} data-testid="state_road_select">
                                                                                    <option value="Yes">Yes</option>
                                                                                    <option value="No">No</option>
                                                                                </select>
                                                                            </div>
                                                                            <div className="station-detail-childt">
                                                                                <label className={'general-label'}>Posted Speed Limit</label>
                                                                                <FilledInput   
                                                                                style={{width:'336px'}}  
                                                                                id="posted_speed_limit" 
                                                                                name="posted_speed_limit"                                                                 
                                                                                type="text" 
                                                                                variant="outlined" 
                                                                                className='form-text-input'
                                                                                onChange={handleChange('posted_speed_limit')}  data-testid="posted_speed_limit" />
                                                                            </div>  
                                                                </div>
                                                                <div className='station-detail-row' style={{width:'100%'}}>
                                                                    <div className="station-detail-childt">
                                                                        <label className={'general-label'}>Number of through lanes for each direction</label>
                                                                    </div>
                                                                </div>
                                                                <div className='station-detail-row' style={{width:'100%', paddingTop:'2px'}}>   
                                                                    {['NB', 'SB', 'EB', 'WB'].map((item,index)=>(
                                                                        <div className="station-detail-childt" style={{width:'23%'}}>
                                                                        <label className={'general-label'}>{item}</label>
                                                                        <FilledInput   
                                                                        style={{width:'100%'}}  
                                                                        id="state_road_text" 
                                                                        name="state_road_text" 
                                                                        className={losDirectionsError.includes(item.toLowerCase()) ? "form-text-input-error" : "form-text-input"} 
                                                                        endAdornment={ losDirectionsError.includes(item.toLowerCase()) && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                                        type="text" 
                                                                        variant="outlined" 
                                                                        disabled={!losDisabledApproaches.includes(item.toLowerCase())}
                                                                        onChange={handleChange(`${item.toLowerCase()}_num_lanes`)} data-testid="state_road_text" />
                                                                    </div>  
                                                                    ))}
                                                                </div>
                                                                <div className='station-detail-row' style={{width:'100%'}}>
                                                                    <div className="station-detail-childt">
                                                                        <label className={'general-label'}>Left Turn within 100 yards of station</label>
                                                                    </div>
                                                                </div>
                                                                <div className='station-detail-row' style={{width:'100%', paddingTop:'2px'}}>
                                                                    {['NB', 'SB', 'EB', 'WB'].map(item=>(
                                                                        <div className="station-detail-childt" style={{width:'23%'}}>
                                                                            <label className={'general-label'}>{item}</label>
                                                                            <select
                                                                            IconComponent={ExpandMoreIcon}
                                                                            id="state_road_select" 
                                                                            name="state_road_select" 
                                                                            style={{width:'100%'}}  
                                                                            className={' general-text-input' } 
                                                                            disabled={!losDisabledApproaches.includes(item.toLowerCase())}
                                                                            onChange={handleChange(`${item.toLowerCase()}_left_turn_within_100_yards`)} data-testid="state_road_select">
                                                                                <option value="Yes">Yes</option>
                                                                                <option value="No">No</option>
                                                                            </select>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                <div className='station-detail-row' style={{width:'100%'}}>    
                                                                    <div className="station-detail-childt" style={{width:'100%'}}>
                                                                        <label className={'general-label'}>Median type</label>
                                                                        <select 
                                                                            IconComponent={ExpandMoreIcon}
                                                                            id="median_type_select" 
                                                                            name="median_type_select" 
                                                                            style={{width:'100%'}}  
                                                                            className={medianTypeError ? "general-text-input error" : "general-text-input"} 
                                                                            onChange={handleChange('FK_median_type_id')} data-testid="median_type_select">
                                                                            <option value="">Select a median type</option>
                                                                        {medianTypes.map(item=>(
                                                                            <option value={item['id']}>{item['name']}</option>
                                                                        ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div className='station-detail-row' style={{width:'100%'}}>    
                                                                    <div className="station-detail-childt" style={{width:'48%'}}>
                                                                        <label className={'general-label'}>Exclusive Left Turn Lane</label>
                                                                    </div>
                                                                </div>
                                                                <div className='station-detail-row' style={{width:'100%', paddingTop:'2px'}}>
                                                                    {['NB', 'SB', 'EB', 'WB'].map(item=>(
                                                                        <div className="station-detail-childt" style={{width:'23%'}}>
                                                                            <label className={'general-label'}>{item}</label>
                                                                            <select
                                                                            IconComponent={ExpandMoreIcon}
                                                                            id="state_road_select" 
                                                                            name="state_road_select" 
                                                                            style={{width:'100%'}}  
                                                                            className={' general-text-input' } 
                                                                            disabled={!losDisabledApproaches.includes(item.toLowerCase())}
                                                                            onChange={handleChange(`${item.toLowerCase()}_exclusive_left_turn_lane`)} data-testid="state_road_select">
                                                                                <option value="Yes">Yes</option>
                                                                                <option value="No">No</option>
                                                                            </select>
                                                                        </div>
                                                                    ))}
                                                                </div>

                                                                <div className='station-detail-row' style={{width:'100%'}}>    
                                                                    <div className="station-detail-childt" style={{width:'48%'}}>
                                                                        <label className={'general-label'}>Exclusive Right Turn Lane</label>
                                                                    </div>
                                                                </div>
                                                                <div className='station-detail-row' style={{width:'100%', paddingTop:'2px'}}>
                                                                    {['NB', 'SB', 'EB', 'WB'].map(item=>(
                                                                        <div className="station-detail-childt" style={{width:'23%'}}>
                                                                            <label className={'general-label'}>{item}</label>
                                                                            <select
                                                                            IconComponent={ExpandMoreIcon}
                                                                            id="state_road_select" 
                                                                            name="state_road_select" 
                                                                            style={{width:'100%'}}  
                                                                            className={' general-text-input' } 
                                                                            disabled={!losDisabledApproaches.includes(item.toLowerCase())}
                                                                            onChange={handleChange(`${item.toLowerCase()}_exclusive_right_turn_lane`)} data-testid="state_road_select">
                                                                                <option value="Yes">Yes</option>
                                                                                <option value="No">No</option>
                                                                            </select>
                                                                        </div>
                                                                    ))}
                                                                </div>

                                                                <div className='station-detail-row' style={{width:'100%'}}>    
                                                                    <div className="station-detail-childt" style={{width:'48%'}}>
                                                                        <label className={'general-label'}>One-Way Roadway</label>
                                                                        <select
                                                                        IconComponent={ExpandMoreIcon}
                                                                        id="one_way_roadway_select" 
                                                                        name="one_way_roadway_select" 
                                                                        style={{width:'100%'}}  
                                                                        className={' general-text-input' } 
                                                                        onChange={handleChange('one_way_roadway')} data-testid="one_way_roadway_select">
                                                                            <option value="Yes">Yes</option>
                                                                            <option value="No">No</option>
                                                                        </select>
                                                                    </div>
                                                                    <div className="station-detail-childt" style={{width:'48%'}}>
                                                                        <label className={'general-label'}>Auxiliary Lanes</label>
                                                                        <select
                                                                        IconComponent={ExpandMoreIcon}
                                                                        id="auxiliary_lanes_select" 
                                                                        name="auxiliary_lanes_select" 
                                                                        style={{width:'100%'}}  
                                                                        className={' general-text-input' } 
                                                                        onChange={handleChange('auxiliary_lanes')} data-testid="auxiliary_lanes_select">
                                                                            <option value="Yes">Yes</option>
                                                                            <option value="No">No</option>
                                                                        </select>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            

                            </div>
              
                      
                        </div>
                        <div className={'station-detail-panel-footer'}>
                           
                             <Button type="reset" variant="outlined" id="cancel_btn" 
                             data-testid="cancel_btn" 
                             style={{width:'71px', height:'34px'}}
                             className={'bg-gray-500 txt-gray-700 font-14'} 
                             onClick={() => { clearStationForm() }}>
                                Cancel</Button>&nbsp;&nbsp;
                           
                            {station_type==1?
                            <Button type="submit" variant="outlined" 
                            id="add_Station_btn" 
                            data-testid="add_Station_btn" 
                            style={{width:'57px', height:'34px'}}
                            disabled={stationIdError == true || stationLocationError == true || stationLatitudeError == true || stationLongitudeError == true  || aproachDetailsErrorMid[0]  == true || aproachDetailsErrorMid[1]  == true ? true : false}
                            
                            className={"blue-btn font-14"}>
                                                                {loader == true ?
                                    <CircularProgress />
                                    : 'Save'}</Button>    
                                


                            :
                            <Button type="submit" variant="outlined" 
                            id="add_Station_btn" 
                            data-testid="add_Station_btn" 
                            style={{width:'57px', height:'34px'}}
                            disabled={stationIdError == true || stationLocationError == true || stationLatitudeError == true || stationLongitudeError == true  || aproachDetailsError[0]  == true || aproachDetailsError[1]  == true  || aproachDetailsError[2]  == true || aproachDetailsError[3]  == true? true : false}
                            
                            className={"blue-btn font-14"}>
                                                                {loader == true ?
                                    <CircularProgress />
                                    : 'Save'}</Button>    
                                


                            }
                            

                               
                        </div>
                        </div>
                        </TabPanel>
                                    
                    </SwipeableViews>
                   
                </form>  
                </Container>
               
            </div>
            {
                showLaneConfig &&
                <LaneGeometry 
                    lat={lat}
                    long={long}
                    stationType={stationType}
                    showLaneConfig={showLaneConfig}
                    setShowLaneConfig={setShowLaneConfig}
                    approachesForLane={Object.values(intAllApproaches)}
                    stationId={null}
                    laneConfigId={laneConfigId}
                    setLaneConfigId={setLaneConfigId}
                />  
            }
            {
                showLOS &&
                (<React.Fragment>  
                    <CssBaseline />
                        <div className="management-main">
                            <Container className="station-management-container" maxWidth="lg">
                            <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => validateForm(e)} data-testid='station_details_from'>
                                <AppBar position="static" color="default" className={(scrolled?'table-scrolled':'') + ' tabs-header station-tabs' }>
                                    <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="fullWidth"
                                    aria-label="full width tabs example"
                                    >
                                        <Tab label="Area classification guide" {...a11yProps(0)} id="userTabb" data-testid="userListTab" className={'main_panel_title_specific main_panel_title'}  style={{ width: '210px', maxWidth: '210px', maxWidth: '210px !important' }} />
                                    </Tabs>
                                    <div className="add-user-cnt">
                                        <img src={require('../../assets/icons/close.svg')} onClick={() => setShowLOS(false)} />
                                    </div>
                                </AppBar>
                                <SwipeableViews
                                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                    index={value}
                                    onChangeIndex={handleChangeIndex}
                                    className={'main_bg'}
                                >
                                    <TabPanel value={value} index={0} dir={theme.direction} >
                                  
                                    <div>
                                    <div className="stations-detail-content ddd "
                                     onScroll={handleScroll}
                                     ref={mainBgRef} >
                                        <div className={'station_container'}>
                                            <div className={'station_container_row'} style={{width: '100%'}}>
                                                <div className="station_card_info m-r-16" style={{width: '100%'}}>
                                                    <img src={require('../../assets/images/LOS_image.png')} style={{width:'100%', height:'350px'}} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    </TabPanel>
                                </SwipeableViews>
                            </form>
                            </Container>
                        </div>
                    </React.Fragment>
            )
            }
        </React.Fragment>
    );
}
export default AddNewStation;
//End AddNewStation component code ...